"use strict";
import { getRequest, postRequest } from "@/services/RequestService";

export const getMyActivity = async () => {
  const base_route = `admin/my_activity`;
  const response = await getRequest(base_route);
  return response;
};

export const viewMyActivity = async id => {
  const base_route = `admin/my_activity/${id}`;
  const response = await getRequest(base_route);
  return response;
};

export const getLog = async id => {
  const base_route = `admin/my_activity/${id}/log`;
  const response = await getRequest(base_route);
  return response;
};

export const storeMyActivity = async request => {
  const base_route = `admin/my_activity/store`;
  const response = await postRequest(base_route, request);
  return response;
};

export const updateMyActivity = async (request, id) => {
  const base_route = `admin/my_activity/${id}`;
  const response = await postRequest(base_route, request);
  return response;
};

export const toggleStatus = async (request, id) => {
  const base_route = `admin/my_activity/update_status/${id}`;
  const response = await postRequest(base_route, request);
  return response;
};

export const storeFeedback = async request => {
  const base_route = `feedbacks/admin/store`;
  const response = await postRequest(base_route, request);
  return response;
};

export const updateFeedback = async (id, request) => {
  const base_route = `feedbacks/admin/${id}/update`;
  const response = await postRequest(base_route, request);
  return response;
};

export const getFeedback = async my_activity_id => {
  const base_route = `feedbacks/${my_activity_id}`;
  const response = await getRequest(base_route);
  return response;
};

export const showFeedback = async id => {
  const base_route = `feedbacks/admin/${id}/show`;
  const response = await getRequest(base_route);
  return response;
};

export const cancelMyActivity = async (id, request) => {
  const base_route = `admin/my_activity/cancel/${id}`;
  const response = await postRequest(base_route, request);
  return response;
};

export const getMoreInfo = async (id, request) => {
  const base_route = `user_activity/${id}/view`
  const response = await postRequest(base_route, request);
  return response;
}



// my activity page for title desc countdown
